import { render, staticRenderFns } from "./AIHead.vue?vue&type=template&id=4df6be30"
import script from "./AIHead.vue?vue&type=script&lang=js"
export * from "./AIHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports